module.exports = __webpack_public_path__ + "static/media/group_event_timeline.38b6d046.svg";